import { createContext } from 'react';

const generalContext = createContext();

export default generalContext;